var map = {
	"./Ellipse.svg": [
		8927,
		8927
	],
	"./Messages/dots.svg": [
		331,
		331
	],
	"./Messages/phoneIcon.svg": [
		2917,
		2917
	],
	"./Partners/settings.svg": [
		5974,
		9391
	],
	"./addUserIcon.svg": [
		5080,
		5080
	],
	"./arrowright.svg": [
		478,
		478
	],
	"./binIcon.svg": [
		1610,
		1610
	],
	"./blackDots.svg": [
		2039,
		2039
	],
	"./chicago.svg": [
		6303,
		6303
	],
	"./circle.svg": [
		7203,
		7203
	],
	"./controls/arrow-left.svg": [
		2343,
		2343
	],
	"./controls/basket.svg": [
		5558,
		5558
	],
	"./controls/copy.svg": [
		7084,
		7084
	],
	"./controls/edit.svg": [
		3300,
		3300
	],
	"./controls/framed-edit.svg": [
		2892,
		2892
	],
	"./controls/paperclip.svg": [
		69,
		69
	],
	"./controls/send.svg": [
		4007,
		5974
	],
	"./controls/settings.svg": [
		4470,
		4470
	],
	"./controls/triple-dots.svg": [
		5658,
		5658
	],
	"./copy.svg": [
		6552,
		6552
	],
	"./decor/dollar.svg": [
		1470,
		1470
	],
	"./decor/group.svg": [
		6150,
		6150
	],
	"./decor/search.svg": [
		8735,
		8735
	],
	"./disableIcon.svg": [
		6883,
		6883
	],
	"./done.svg": [
		7629,
		7629
	],
	"./dotsIcon.svg": [
		8102,
		8102
	],
	"./emailsetting.svg": [
		5720,
		5720
	],
	"./horiz.svg": [
		7083,
		7083
	],
	"./links/black-phone.svg": [
		5450,
		5450
	],
	"./links/email.svg": [
		9244,
		9244
	],
	"./links/grey-phone.svg": [
		8447,
		8447
	],
	"./links/map.svg": [
		4051,
		4051
	],
	"./links/reply.svg": [
		9285,
		9285
	],
	"./links/white-phone.svg": [
		1585,
		1585
	],
	"./loadboard/arrowIcon.svg": [
		7756,
		7756
	],
	"./loadboard/copyIcon.svg": [
		5028,
		5028
	],
	"./loadboard/dashIcon.svg": [
		9190,
		9190
	],
	"./loadboard/destinationIcon.svg": [
		1253,
		1253
	],
	"./loadboard/emailIcon.svg": [
		6569,
		6569
	],
	"./loadboard/frame.svg": [
		9718,
		9718
	],
	"./loadboard/groupIcon.svg": [
		7455,
		7455
	],
	"./loadboard/mapIcon.svg": [
		7080,
		7080
	],
	"./loadboard/mapImage.svg": [
		8162,
		8162
	],
	"./loadboard/phoneIcon.svg": [
		5334,
		5334
	],
	"./loadboard/printIcon.svg": [
		9913,
		9913
	],
	"./loadboard/starIcon.svg": [
		1247,
		1247
	],
	"./loadboardEmail/attach.svg": [
		5636,
		5636
	],
	"./loadboardEmail/circle.svg": [
		39,
		39
	],
	"./loadboardEmail/close.svg": [
		8481,
		8481
	],
	"./loadboardEmail/cross.svg": [
		2241,
		2241
	],
	"./loadboardEmail/lineIcon.svg": [
		2286,
		2286
	],
	"./loadboardEmail/reply.svg": [
		3530,
		3530
	],
	"./loadboardEmail/smartphone.svg": [
		5140,
		5140
	],
	"./loadboardEmail/threeDotsIcon.svg": [
		7000,
		7000
	],
	"./log-out.svg": [
		7798,
		7798
	],
	"./logocompany.svg": [
		397,
		397
	],
	"./my BIds/Frame.svg": [
		1661,
		1661
	],
	"./pen.svg": [
		8795,
		8795
	],
	"./pencil.svg": [
		3163,
		3163
	],
	"./placeholders/dash.svg": [
		7954,
		7954
	],
	"./plusIcon.svg": [
		6533,
		6533
	],
	"./script.svg": [
		1050,
		1050
	],
	"./search.svg": [
		5726,
		5726
	],
	"./sidebar/accounting.svg": [
		9587,
		9587
	],
	"./sidebar/addLoad.svg": [
		625,
		625
	],
	"./sidebar/arrowDown.svg": [
		7867,
		7867
	],
	"./sidebar/capacitySearch.svg": [
		4623,
		4623
	],
	"./sidebar/dashboard.svg": [
		8373,
		8373
	],
	"./sidebar/groupChats.svg": [
		6504,
		6504
	],
	"./sidebar/home.svg": [
		8280,
		8280
	],
	"./sidebar/loadboard.svg": [
		6308,
		6308
	],
	"./sidebar/myBids.svg": [
		4990,
		4990
	],
	"./sidebar/myLoads.svg": [
		8337,
		8337
	],
	"./sidebar/notification.svg": [
		9296,
		9296
	],
	"./sidebar/search.svg": [
		6804,
		6804
	],
	"./sidebar/settings.svg": [
		7580,
		7580
	],
	"./sidebar/sms.svg": [
		7816,
		7816
	],
	"./sidebar/units.svg": [
		7059,
		7059
	],
	"./sidebar/wiserLogo.svg": [
		497,
		497
	],
	"./trashBin.svg": [
		8673,
		8673
	],
	"./user.svg": [
		1996,
		1996
	],
	"./warningIcon.svg": [
		4725,
		4725
	],
	"./weather/clear-day.svg": [
		2149,
		2149
	],
	"./weather/clear-night.svg": [
		5143,
		5143
	],
	"./weather/cloudy.svg": [
		118,
		118
	],
	"./weather/fog.svg": [
		2574,
		2574
	],
	"./weather/hail.svg": [
		8858,
		8858
	],
	"./weather/partly-cloudy-day.svg": [
		5995,
		5995
	],
	"./weather/partly-cloudy-night.svg": [
		4282,
		4282
	],
	"./weather/rain-snow-showers-day.svg": [
		924,
		924
	],
	"./weather/rain-snow-showers-night.svg": [
		5614,
		5614
	],
	"./weather/rain-snow.svg": [
		2602,
		2602
	],
	"./weather/rain.svg": [
		7350,
		7350
	],
	"./weather/showers-day.svg": [
		7511,
		7511
	],
	"./weather/showers-night.svg": [
		9873,
		9873
	],
	"./weather/sleet.svg": [
		5129,
		5129
	],
	"./weather/snow-showers-day.svg": [
		6547,
		6547
	],
	"./weather/snow-showers-night.svg": [
		9146,
		9146
	],
	"./weather/snow.svg": [
		4026,
		4026
	],
	"./weather/thunder-rain.svg": [
		2073,
		2073
	],
	"./weather/thunder-showers-day.svg": [
		1358,
		1358
	],
	"./weather/thunder-showers-night.svg": [
		7082,
		7082
	],
	"./weather/thunder.svg": [
		6749,
		6749
	],
	"./weather/wind.svg": [
		6714,
		6714
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1019;
module.exports = webpackAsyncContext;